import Button from 'src/app/components/Elements/Button';

import { BaseModal } from '../Base/BaseModal';

import { ModalContainer, ModalInfoText, ModalTitleText } from './styles';

interface CheckoutTransferModalProps {
  handleButtonClickAndExit: () => void;
  showModal: boolean;
  title: string;
  buttonText: string;
  bodyText: string;
}

export const CheckoutTransferModal = ({
  handleButtonClickAndExit,
  showModal,
  title,
  buttonText,
  bodyText,
}: CheckoutTransferModalProps) => {
  const genericModalId = 'checkout-transfer-modal';
  const describedById = 'checkout-transfer-modal-describedby-id';
  return (
    <BaseModal
      handleModalClosed={handleButtonClickAndExit}
      showModal={showModal}
      ariaLabeledById={genericModalId}
      ariaDescribedById={describedById}
    >
      <ModalContainer>
        <ModalTitleText id={genericModalId}>{title}</ModalTitleText>
        <ModalInfoText id={describedById}>{bodyText}</ModalInfoText>
        <Button style="secondary" size="medium" onClick={handleButtonClickAndExit}>
          {buttonText}
        </Button>
      </ModalContainer>
    </BaseModal>
  );
};
